import React from 'react'
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { Form, FormGroup } from 'reactstrap';
import FormItem from '../../../common/forms/FormItem';
import CustomerSelect from '../../../common/forms/select/CustomerSelect';
import { isRequired, validateEndDate } from '../../../../utils/validators';
import DatePicker from '../../../common/forms/input/DatePicker';
import FormFooter from '../../../common/forms/FormFooter';

const validateDate = (value, allValues) =>
  validateEndDate(value, allValues.fromDateString);

const LegalTicketForm = ({
  handleSubmit,
  loading,
}) => (
  <Form onSubmit={handleSubmit}>
    <FormGroup row>
      <FormItem label="Cliente" required>
        <Field
          name="customer"
          component={CustomerSelect}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Desde" required>
        <Field
          name="fromDateString"
          component={DatePicker}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Hasta" required>
        <Field
          name="toDateString"
          component={DatePicker}
          validate={[isRequired, validateDate]}
        />
      </FormItem>
    </FormGroup>
    <FormFooter
      saveButtonText="Buscar"
      saveButtonIcon="fa fa-search"
      saveButtonColor="primary"
      saveButtonDisabled={loading}
    />
  </Form>
)

LegalTicketForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

LegalTicketForm.defaultProps = {
  loading: false,
};

export default reduxForm({
  form: 'legalTicketForm',
})(LegalTicketForm);


